export default __webpack_public_path__ + "a08cc616f131723a2ca2e8c7ef68cfdf.jpg";